import { Box, Text } from '@cad-arc';
import { Mark } from '../../../common/components/mark';

export function LocationSelectHint({ size }: { size?: string }) {
    const markProps = { style: { mx: 1, px: 1 } };
    return (
        <Box w="100%" px={8} py={4}>
            <ul>
                <li>
                    <Text fontSize={size}>
                        Use a pound
                        <Mark {...markProps}>#</Mark>
                        to include sub-premises (i.e. apartment, building) in the search, like{' '}
                        <Mark {...markProps}>#423A</Mark> or <Mark {...markProps}>#Apt</Mark>
                    </Text>
                </li>
                <li>
                    <Text fontSize={size}>
                        Optionally use a colon <Mark {...markProps}>:</Mark> to search a specific
                        sub premise name for a value, like <Mark {...markProps}>#Building:12</Mark>
                    </Text>
                </li>
            </ul>
        </Box>
    );
}
